<template>
  <div>
    <pc-header class="pc-show"></pc-header>
    <phone-header class="phone-show"></phone-header>
    <transition name="slide-fade">
      <phone-header class="transition-header phone-show" v-show="headerFixed"></phone-header>
    </transition>
  </div>
</template>

<script>
  import PcHeader from './UserCenterHeaderPc.vue'
  import PhoneHeader from './UserCenterHeaderM.vue'
  import LogoInHeader from '../../logoInHeader/LogoInHeader.vue'
  import $ from 'jquery'

  export default {
    name: 'user-center-header-box',
    components: {
      PcHeader,
      LogoInHeader,
      PhoneHeader
    },
    data() {
      return {
        headerFixed: false
      }
    },
    created() {
      window.addEventListener('scroll', this.showHeader)
      this.$store.dispatch('getUserInformation', window.sessionStorage.getItem('needUseNoCache')).then((response) => {
        this.$store.dispatch('getCommissionApplyStatus')
      })
    },
    destroyed() {
      window.removeEventListener('scroll', this.showHeader)
    },
    methods: {
      showHeader: function () {
        if ($(window).scrollTop() >= 300) {
          this.headerFixed = true
          this.$store.commit('setPhoneHeaderLogoFlag', true)
        } else {
          this.headerFixed = false
          this.$store.commit('setPhoneHeaderLogoFlag', false)
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .transition-header {
    position: fixed;
    top: 0;
    z-index: 3;
    width: 100%;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.10);
  }

  .slide-fade-enter-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-leave-active {
    transition: all .2s ease;
  }

  .slide-fade-enter, .slide-fade-leave-active {
    transform: translateY(-10px);
    opacity: 0;
  }

  @media (min-width: 992px) {
    .phone-show {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .pc-show {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?9b6755fc